import {ChangeDetectionStrategy, Component, computed, OnInit, signal} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {AlertService} from "../../services/alert.service";
import {UtilService} from "../../services/util.service";
import {Constants} from "../../util/constants";
import {finalize} from "rxjs/operators";
import {BusyService} from "../../services/busy.service";
import {StateService} from "../../services/state.service";
import {SessionService} from "../../services/session.service";
import {RouterLink} from '@angular/router';
import {MatButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {MatError, MatFormField} from '@angular/material/form-field';
import {form, FormField, pattern, required} from "@angular/forms/signals";
import {FieldErrorsComponent} from "../../controls/field-errors/field-errors.component";

const RESET_LINK_SENT_MSG = "If your email is registered, you'll soon receive a link<br/> to change you password.";

interface ForgotPasswordModel {
    email: string;
}

@Component({
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatInput, MatError, MatButton, RouterLink, FieldErrorsComponent, FormField]
})
export class ForgotPasswordComponent implements OnInit {

    isBusy = computed(() => this.busyService.isBusy());

    forgotPasswordModel = signal<ForgotPasswordModel>({
       email: ''
    });
    forgotPasswordForm = form(this.forgotPasswordModel, (schemaPath) => {
        required(schemaPath.email, {message: Constants.ERR_REQUIRED});
        pattern(schemaPath.email, Constants.EMAIL_REGEX, {message: Constants.ERR_INVALID_EMAIL});
    });

    constructor(private authService: AuthService,
                private alertService: AlertService,
                private busyService: BusyService,
                private state: StateService,
                private sessionService: SessionService,
                private utilService: UtilService) {
    }

    ngOnInit() {
        if (this.authService.isLoggedIn()){
            this.busyService.showBusy();
            this.authService.logOut().pipe(
                finalize(() => {this.busyService.showNotBusy()})
            ).subscribe({
                next: () => {
                    this.state.clearAll();
                    this.sessionService.clearSession();
                },
                error: this.utilService.getErrorHandler("Error in auto logout")
            });
        }
    }

    submit(event: SubmitEvent) {
        event.preventDefault();
        this.busyService.showBusy();
        this.authService.requestPasswordReset(this.forgotPasswordForm.email().value()).pipe(
            finalize(() => { this.busyService.showNotBusy() })
        ).subscribe({
            next: () => {
                this.alertService.info(RESET_LINK_SENT_MSG);
            },
            error: this.utilService.getErrorHandler("Error requesting password reset")
        });
    }
}
